export function getNotifLink(n, user) {
  const role = user?.role;
  if (n.url && typeof n.url === "string" && n.url.startsWith("/")) return n.url;
  if (role === "client") {
    if (n.entity_type === "job" && n.entity_id) return `/portal/jobs/${n.entity_id}`;
    if (n.entity_type === "job_request" && n.entity_id) return `/portal/requests/${n.entity_id}`;
    if (n.entity_type === "emergency" && n.entity_id) return `/portal/emergencies/${n.entity_id}`;
    if (n.entity_type === "project" && n.entity_id) return `/portal/projects/${n.entity_id}`;
    if (n.entity_type === "contract") return n.entity_id ? `/portal/contracts/${n.entity_id}` : "/portal/contracts";
    if (n.entity_type === "quote") return "/portal/quotes";
    if (n.entity_type === "invoice") return n.entity_id ? `/portal/invoices/${n.entity_id}` : "/portal/invoices";
    if (n.entity_type === "client") return "/portal/messages";
    return "/portal";
  }
  const isVendor = role === "vendor";
  const isInHouse = role === "in_house" || role === "vendor_operative";
  if (n.entity_type === "task" && n.entity_id) return `/tasks/${n.entity_id}`;
  if (n.entity_type === "inbox_email" && n.entity_id) return `/inbox?item=${n.entity_id}`;
  if (n.entity_type === "work_order" && n.entity_id) return isVendor ? `/supplier-portal/work-orders/${n.entity_id}` : `/work-orders?open=${n.entity_id}`;
  if (n.entity_type === "in_house_po" && n.entity_id) return isInHouse ? `/my-work/pos/${n.entity_id}` : `/in-house/pos/${n.entity_id}`;
  if (n.entity_type === "job" && n.entity_id) return isInHouse ? `/my-work/jobs/${n.entity_id}` : `/jobs/${n.entity_id}`;
  if (n.entity_type === "job_request" && n.entity_id) return `/job-requests/${n.entity_id}`;
  if (n.entity_type === "project" && n.entity_id) return `/projects/${n.entity_id}`;
  if (n.entity_type === "contract") return isVendor ? "/supplier-portal" : isInHouse ? "/my-work" : n.entity_id ? `/contracts/${n.entity_id}` : "/contracts";
  if (n.entity_type === "quote" && n.entity_id) return `/quotes/${n.entity_id}`;
  if ((n.entity_type === "emergency" || n.entity_type === "emergency_job") && n.entity_id) return isInHouse ? `/my-work/emergency/${n.entity_id}` : `/emergency-jobs/${n.entity_id}`;
  if (n.entity_type === "staff_monitoring") return `/staff-monitoring`;
  if (n.entity_type === "task_compliance") return `/vendors`;
  if (n.entity_type === "compliance" || n.entity_type === "vendor") return `/vendors`;
  if (n.entity_type === "vendor_message") return `/messages`;
  if (n.entity_type === "client" && n.entity_id) return `/clients/${n.entity_id}`;
  if (n.entity_type === "invoice") return `/invoices`;
  return null;
}
